
import "reflect-metadata";
import { Container } from "inversify";
import HeaderBar from "FF/Vue/ControlCenter/Layouts/HeaderBar.vue";
import SideBar from "FF/Vue/ControlCenter/Layouts/SideBar/SideBar.vue";

const Provider = new Container();

Vue.component('ControlCenterHeaderBar', HeaderBar);
Vue.component('ControlCenterSideBar', SideBar);

export default Provider;